import { useTranslation } from 'react-i18next';
import React, { FunctionComponent, useEffect, useState } from "react";
import { Button, Col, DatePicker, Form, Row, Typography } from "antd";
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import "./filter-group.scss";
import { FormInstance } from "antd/lib";
// import { dataStatus } from '../../../pages/list-user/constants/data';
import { get } from "lodash";

import type { DatePickerProps } from "antd";
import { Dayjs } from "dayjs";
import { FilterData } from "./filter";
import FormItemDropdown from "../../form-dropdown/FormItemDropdown";
import { getProvinces } from "../../../pages/user-info/account/services";

type FormFilterProps = {
  handleCloseFilter: () => void;
  tab: string;
  showFilter?: boolean;
  form: FormInstance;
  clearFilter: () => void;
  onFinish?: () => void;
  setFilterData: (dateString: string[], planCreationDate: string) => void;
  dataOptions?: any;
  filterData: any;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  handleCloseFilter,
  onFinish,
  form,
  showFilter,
  clearFilter,
  dataOptions,
  filterData,
  setFilterData,
  tab,
}) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;
  const [listProvince, setListProvince] = useState<any>([])
  const listStatus = [
    {
      id: 0,
      name: t('Nháp', 'Nháp')
    },
    {
      id: 1,
      name: t('Áp dụng', 'Áp dụng')
    },
  ]

  const getListProvinces = async () => {
    await getProvinces().then((res) => {
      if (res.status === 200) {
        const data = res.data.data?.map((item: any) => ({
          id: item.code,
          name: item.name,
        }))
        setListProvince(data)
      }
    })
  }

  useEffect(() => {
    if (showFilter) {
      getListProvinces()
    }
  }, [showFilter])

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form form={form} name="filterForm" onFinish={onFinish}>
          <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
            <Col
              xl={{ span: 5 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>
                {t("Tỉnh", "Tỉnh")}
              </Typography.Title>
              <Form.Item name="status">
                <FormItemDropdown placeholder={t("Chọn tỉnh", "Chọn tỉnh")} onChange={(option) => setFilterData(option, 'status')}
                  options={listProvince} />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 4 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Chọn", "Chọn")} {tab === "1" ? t("Ngày gửi", "Ngày gửi") : t("Ngày xử lý", "Ngày xử lý")}</Typography.Title>
              <Form.Item name="approvedDate">
                <RangePicker
                  placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]}
                  format="YYYY-MM-DD"
                  value={filterData.approvedDate}
                  onChange={(_value, dateString: any) =>
                    setFilterData(dateString, "approvedDate")
                  }
                />
              </Form.Item>
            </Col>

            <Col
              xl={{ span: 3 }}
              md={{ span: 9 }}
              sm={{ span: 9 }}
              xs={{ span: 24 }}
              className="flex align-end"
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary filter-btn"
                  htmlType="submit"
                  onClick={() => form.submit()}
                >
                  <FilterOutlined />
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={clearFilter}
                >
                  <DeleteOutlined />
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
